import { useTranslation } from "react-i18next";

export default function WhyUs() {
  const { t } = useTranslation();

  const items = [
    {
      icon: "ri-map-2-line",
      title: t("wu_local_experts"),
      body: t("wu_local_experts_body"),
      color: "accent" as const,
    },
    {
      icon: "ri-global-line",
      title: t("wu_languages"),
      body: t("wu_languages_body"),
      color: "primary" as const,
    },
    {
      icon: "ri-hand-heart-line",
      title: t("wu_handpicked"),
      body: t("wu_handpicked_body"),
      color: "primary" as const,
    },
    {
      icon: "ri-message-3-line",
      title: t("wu_personal"),
      body: t("wu_personal_body"),
      color: "accent" as const,
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100 relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs uppercase tracking-[0.2em] text-accent-600 font-medium mb-3">
          {t("wu_badge")}
        </span>
        <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
          {t("wu_heading")}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-12 leading-relaxed max-w-2xl mx-auto">
          {t("wu_subtitle")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-left">
          {items.map((it) => (
            <div key={it.title} className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 ${
                it.color === "accent" ? "bg-accent-100" : "bg-primary-100"
              }`}>
                <i className={`${it.icon} text-xl ${
                  it.color === "accent" ? "text-accent-700" : "text-primary-700"
                }`}></i>
              </div>
              <div>
                <div className="font-medium text-foreground-950 mb-1">{it.title}</div>
                <div className="text-sm text-foreground-600 leading-relaxed">{it.body}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}